import { FC } from "react";
import CPanelPage from "@web-src/modules/workspace/pages/CPanelPage";
import { CXWorkspaceAdminLayout } from "../CXWorkspaceAdminLayout";

export const CXWorkspaceTeamMembersPage: FC = () => (
  <CXWorkspaceAdminLayout>
    <CPanelPage useDefaultLayout={false} />
  </CXWorkspaceAdminLayout>
);
